<template lang='pug'>
  .loyalty-tiers(v-if='loyaltyTiers.length > 0')
    template(v-if='loyaltyTiers.length === 1')
      .tier-title(:class='loyaltyTiers[0]' v-t='`bookingService.${loyaltyTiers[0]}Tier`')
    template(v-else-if='loyaltyTiers[0] === `all`')
      .tier-title(v-html="$t('bookingService.allTiers')")
    template(v-else)
      .tier-title(v-html="$t('bookingService.goldBlackTier')")
</template>

<i18n>
{
  "lng_en": {
    "bookingService": {
      "blackTier": "Black tier",
      "goldTier": "Gold tier",
      "allTiers": "<span class=\"all-tiers\">All members</span>",
      "goldBlackTier": "<span class=\"gold\">Gold</span><span class=\"tier-separator\"> & </span>Black tier"
    }
  },
  "lng_zh": {
    "bookingService": {
      "blackTier": "黑卡會籍",
      "goldTier": "金卡會籍",
      "allTiers": "<span class=\"all-tiers\">所有成員</span>",
      "goldBlackTier": "<span class=\"gold\">金卡</span><span class=\"tier-separator\">及</span>黑卡會籍"
    }
  },
  "lng_th": {
    "bookingService": {
      "blackTier": "เทียร์ Black",
      "goldTier": "เทียร์ Gold",
      "allTiers": "<span class=\"all-tiers\">สมาชิกทุกท่าน</span>",
      "goldBlackTier": "เทียร์ <span class=\"gold\">Gold</span><span class=\"tier-separator\"> และ </span>Black"
    }
  },
  "lng_id": {
    "bookingService": {
      "blackTier": "Tier Black",
      "goldTier": "Tier Gold",
      "allTiers": "<span class=\"all-tiers\">Semua anggota</span>",
      "goldBlackTier": "Tier <span class=\"gold\">Gold</span><span class=\"tier-separator\"> & </span>Black"
    }
  },
  "lng_ko": {
    "bookingService": {
      "blackTier": "블랙 뷰티패스 등급",
      "goldTier": "골드 뷰티패스 등급",
      "allTiers": "<span class=\"all-tiers\">모두 회원</span>",
      "goldBlackTier": "<span class=\"gold\">골드</span><span class=\"tier-separator\"> & </span>블랙 뷰티패스 등급"
    }
  }
}
</i18n>

<script>
import isEmpty from 'lodash/isEmpty'

export default {
  name: 'LoyaltyTiers',
  props: {
    loyaltyTier: { type: String, default: '' }
  },

  computed: {
    loyaltyTiers () {
      if (!isEmpty(this.loyaltyTier)) {
        return this.loyaltyTier.split('_')
      } else {
        return []
      }
    }
  }
}
</script>

<style lang='scss'>
  .gold {
    color: #ab892e;
  }

  .tier-separator {
    color: #999999;
  }

  .all-tiers {
    color: $brand-primary;
  }
</style>

<style scoped lang='scss'>
  .loyalty-tiers {
    line-height: 20px;
    margin-top: -5px;
    margin-bottom: 5px;
  }

  .tier-title {
    font-size: 12px;
    @include font-weight-medium;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
</style>
